import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { ComponentProps } from 'react';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalDescription,
  ModalTitle,
} from '../../../../../design-system/modal/modal';
import { MarkNotInvoiceModalContent } from './mark-not-invoice-modal-content';

type MarkNotInvoiceModalProps = {
  isOpen: boolean;
  invoiceInfo: ComponentProps<typeof MarkNotInvoiceModalContent>['invoiceInfo'];
  isLoading: boolean;
  onClose: () => void;
  onMarkNotInvoice: () => Promise<void>;
};

export const MarkNotInvoiceModal = ({
  isOpen,
  invoiceInfo,
  isLoading,
  onClose,
  onMarkNotInvoice,
}: MarkNotInvoiceModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-max w-[520px] p-7">
        <VisuallyHidden>
          <ModalTitle>Mark not invoice</ModalTitle>

          <ModalDescription>Mark not invoice</ModalDescription>
        </VisuallyHidden>

        <ModalCloseButton onClick={onClose} aria-label="Close modal" />

        <MarkNotInvoiceModalContent
          invoiceInfo={invoiceInfo}
          isLoading={isLoading}
          onMarkNotInvoice={onMarkNotInvoice}
        />
      </ModalContent>
    </Modal>
  );
};
